<template>
    <Component
        :is="disabled ? 'span' : 'button'"
        :type="type"
        :class="classList"
        style="height: 38px; min-width: 38px;"
        v-on="listeners"
    >
        <slot />
    </Component>
</template>

<script>
    export default {
        name: 'C1PaginatorPage',

        props: {
            disabled: {
                type: Boolean,
                default: false,
            },

            active: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
            };
        },

        computed: {
            classList() {
                return [
                    'afu-mx-1 afu-inline-flex afu-items-center afu-justify-center afu-px-3 afu-rounded-lg afu-border afu-border-solid afu-border-gray-300 afu-text-sm focus:afu-outline-none afu-leading-5 afu-transition afu-ease-in-out afu-duration-150',
                    this.getTextColorClass,
                    this.getBgColorClass,
                ];
            },

            getTextColorClass() {
                return this.active ? 'afu-text-white' : 'afu-text-primary-400';
            },

            getBgColorClass() {
                if (this.active) {
                    return 'af-pagination-active afu-bg-primary-400';
                }

                return this.disabled ? 'afu-bg-white' : 'afu-bg-white active:bg-primary-400';
            },

            type() {
                return this.disabled ? undefined : 'button';
            },

            listeners() {
                return this.$listeners;
            },
        },

        methods: {},
    };
</script>
